import { ORGANIZATION_TYPES_SHORT } from "@/utils/constants";

export const organizationFields = [
  { 
    field: 'name', 
    visible: [ORGANIZATION_TYPES_SHORT.ALL], 
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Organization name is required.' 
  },
  {
    field: 'address1',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'Address is required.'
  },
  {
    field: 'address2',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [],
    validationMessage: 'Address 2 is required.'
  },
  {
    field: 'city',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'City is required.'
  },
  {
    field: 'stateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'State is required.'
  },
  {
    field: 'postalCode',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'Postal code is required.'
  },
  {
    field: 'phone',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Phone number is required.'
  },
  {
    field: 'countyId',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE],
    required: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    validationMessage: 'County is required.'
  },
  {
    field: 'fax',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Fax number is required.'
  },
  {
    field: 'otherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE],
    required: [ORGANIZATION_TYPES_SHORT.FOSC],
    validationMessage: 'Other county name is required.'
  },
  {
    field: 'mailAddress1',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Mailing address is required.'
  },
  {
    field: 'mailAddress2',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: []
  },
  {
    field: 'mailCity',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Mailing city is required.'
  },
  {
    field: 'mailStateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Mailing state is required.'
  },
  {
    field: 'mailPostalCode',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Mailing postal code is required.'
  },
  {
    field: 'mailCountyId',
    visible: [ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Mailing county is required.'
  },
  {
    field: 'mailOtherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Other mailing county name is required.'
  },
  {
    field: 'webUrl',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Website URL is required.'
  },
  {
    field: 'fiscalYearEnd',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Fiscal year end is required.'
  },
  {
    field: 'openDate',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    validationMessage: 'Open date is required.'
  },
  {
    field: 'closeDate',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    validationMessage: 'Close date is required.'
  },
  {
    field: 'npiNumber',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'NPI number is required.'
  },
  {
    field: 'naicNumber',
    visible: [ORGANIZATION_TYPES_SHORT.HP],
    required: [ORGANIZATION_TYPES_SHORT.HP],
    validationMessage: 'NAIC number is required.'
  },
  {
    field: 'groupCode',
    visible: [ORGANIZATION_TYPES_SHORT.HP],
    required: [],
    validationMessage: 'Group code is required.'
  },
  {
    field: 'taxId',
    visible: [ORGANIZATION_TYPES_SHORT.URO],
    required: [],
    validationMessage: 'Tax ID is required.'
  }
 
];

export const contactFields = [
  { 
    field: 'firstName', 
    visible: [ORGANIZATION_TYPES_SHORT.ALL], 
    required: [ORGANIZATION_TYPES_SHORT.ALL] 
  },
  {
    field: 'lastName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'address1',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'address2',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'city',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'stateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'postalCode',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'countyId',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'otherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'phone',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'phoneExtension',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'fax',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'email',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'title',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.URO]
  }
];

export const registerContactFields = [
  { 
    field: 'contactFirstName', 
    visible: [ORGANIZATION_TYPES_SHORT.ALL], 
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'First name is required.' 
  },
  {
    field: 'contactLastName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Last name is required.'
  },
  {
    field: 'contactAddress1',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Address is required.'
  },
  {
    field: 'contactAddress2',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Address 2 is required.'
  },
  {
    field: 'contactCity',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'City is required.'
  },
  {
    field: 'contactStateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'State is required.'
  },
  {
    field: 'contactPostalCode',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Postal code is required.'
  },
  {
    field: 'contactCountyId',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'County is required.'
  },
  {
    field: 'contactOtherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Other county name is required.'
  },
  {
    field: 'contactPhone',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage:  'Phone number is required.'
  },
  {
    field: 'contactPhoneExtension',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Phone extension is required.'
  },
  {
    field: 'contactFax',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Fax number is required.'
  },
  {
    field: 'contactEmail',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Email is required.'
  },
  {
    field: 'contactTitle',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.URO],
    validationMessage: 'Title is required.'
  }
];
